import React from "react";

interface SalesTargetRow {
  Assigne: string;
  product_code_prefix: string | null;
  product_code: string;
  product_name: string;
  unit_name: string;
  sales_target: number;
  actual_sales: number;
  target_amount: number;
  sales_amount: number;
  min: number;
}

function formatNumber(value: number) {
  if (value === undefined || value === null) return "-";
  return Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  });
}

function formatCurrency(value: number) {
  if (value === undefined || value === null) return "-";
  return Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

function SalesTargetReportTable({ data }: { data?: SalesTargetRow[] }) {
  const rows = data || [];

  if (!rows.length) {
    return (
      <div className="flex items-center justify-center py-16 text-gray-400 text-sm">
        No data available.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto border border-gray-200 shadow-sm">
      <table className="w-full border-collapse text-sm text-left">
        <thead>
          <tr className="bg-[#002C76] text-white">
            <th className="px-4 py-3 font-semibold whitespace-nowrap">Assigne</th>
            <th className="px-4 py-3 font-semibold whitespace-nowrap">Product Code</th>
            <th className="px-4 py-3 font-semibold whitespace-nowrap">Description</th>
            <th className="px-4 py-3 font-semibold whitespace-nowrap">Unit</th>
            <th className="px-4 py-3 text-right font-semibold whitespace-nowrap">Sales Target</th>
            <th className="px-4 py-3 text-right font-semibold whitespace-nowrap">Actual Sales</th>
            <th className="px-4 py-3 text-right font-semibold whitespace-nowrap">Target Amount</th>
            <th className="px-4 py-3 text-right font-semibold whitespace-nowrap">Sales Amount</th>
            <th className="px-4 py-3 text-right font-semibold whitespace-nowrap">Min</th>
            <th className="px-4 py-3 text-right font-semibold whitespace-nowrap">Max</th>
            <th className="px-4 py-3 text-right font-semibold whitespace-nowrap">Avg</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => {
            const isTotalRow = row.Assigne === "Total";
            
            // Format product code prefix + product_code
            const productCode = isTotalRow
              ? ""
              : `${row.product_code_prefix || ""}${row.product_code || ""}`;

            return (
              <tr
                key={idx}
                className={
                  isTotalRow
                    ? "bg-blue-50 border-t-2 border-blue-200 font-bold text-[#002C76]"
                    : idx % 2 === 0
                    ? "bg-white hover:bg-gray-50 border-b border-gray-100"
                    : "bg-gray-50 hover:bg-gray-100 border-b border-gray-100"
                }
              >
                <td className="px-4 py-3 font-medium">
                  {row.Assigne || "-"}
                </td>
                <td className="px-4 py-3 font-mono text-xs text-gray-700">
                  {productCode}
                </td>
                <td className="px-4 py-3 text-gray-600">
                  {row.product_name || "-"}
                </td>
                <td className="px-4 py-3 text-gray-600">
                  {row.unit_name || "-"}
                </td>
                <td className="px-4 py-3 text-right text-gray-800">
                  {formatNumber(row.sales_target)}
                </td>
                <td className="px-4 py-3 text-right text-gray-800">
                  {formatNumber(row.actual_sales)}
                </td>
                <td className="px-4 py-3 text-right text-gray-800">
                  {formatCurrency(row.target_amount)}
                </td>
                <td className="px-4 py-3 text-right text-gray-800">
                  {formatCurrency(row.sales_amount)}
                </td>
                <td className="px-4 py-3 text-right text-gray-800">
                  {formatNumber(row.min)}
                </td>
                <td className="px-4 py-3 text-right text-gray-800">
                  {formatNumber(row.min)}
                </td>
                <td className="px-4 py-3 text-right text-gray-800">
                  {formatNumber(row.min)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default SalesTargetReportTable;
